export const authConstants = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",

  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",

  FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",

  VALIDATE_TOKEN_REQUEST: "VALIDATE_TOKEN_REQUEST",
  VALIDATE_TOKEN_SUCCESS: "VALIDATE_TOKEN_SUCCESS",
  VALIDATE_TOKEN_FAILURE: "VALIDATE_TOKEN_FAILURE",

  SET_PASSWORD_REQUEST: "SET_PASSWORD_REQUEST",
  SET_PASSWORD_SUCCESS: "SET_PASSWORD_SUCCESS",
  SET_PASSWORD_FAILURE: "SET_PASSWORD_FAILURE",
};

export const roleConstants = {
  ADMIN: "ADMIN",
  PARTNER: "PARTNER",
  STAFF: "STAFF",
  LEGAL: "LEGAL",
  LICENSOR: "LICENSOR",
  DIAGNOSTIC_ADMIN: "DIAGNOSTIC_ADMIN",
  DIAGNOSTIC_REVIEWER: "DIAGNOSTIC_REVIEWER",
};
